<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container"  style="width:100% !important">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- Notification Type -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Notification Type :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <template v-if="editId != 0">
                                    <span class="form-control">{{notificationType.text}}</span>
                                </template>
                                <template v-else>
                                    <v-select v-model="notificationType"
                                        name="notificationType"
                                        id="notificationType"
                                        label="text"
                                        :options="notificationTypeArr"
                                        :clearable=false
                                        :searchable="false"
                                        @input="notificationTypeError = ''"
                                        placeholder="Select Notification Type">
                                    </v-select>
                                </template>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{notificationTypeError}}</span>
                            </div>
                        </div>
                        <!-- Customer -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Customer :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <template v-if="editId != 0">
                                    <span class="form-control">{{customerId.text}}</span>
                                </template>
                                <template v-else>
                                    <v-select v-model="customerId"
                                        name="customerId"
                                        id="customerId"
                                        label="text"
                                        :filterable="true"
                                        :options="customerArr"
                                        :clearable=false
                                        @input="onChnageCustomer()"
                                        placeholder="Select Customer">
                                    </v-select>
                                </template>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{customerError}}</span>
                            </div>
                        </div>
                        <!-- To Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">To Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <vue-tags-input
                                    v-model="toEmail"
                                    :tags="toEmailTagsArr"
                                    :validation="validation"
                                    @tags-changed="newTags => toEmailTagsArr = newTags"
                                    @before-adding-tag="checkToEmailTag"
                                    placeholder=""
                                />
                                <div class="help is-danger">{{toEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- CC Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">CC Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <input type="text" maxlength="190" class="form-control" v-model="ccEmail" id="ccEmail" placeholder="Enter CC Email" name="ccEmail"> -->
                                <!--<input @input="emailError = ''" id="email" v-model="email" class="form-control" type="text"/>-->
                                <vue-tags-input
                                    v-model="ccEmail"
                                    :tags="ccEmailTagsArr"
                                    :validation="validation"
                                    @tags-changed="newTags => ccEmailTagsArr = newTags"
                                    @before-adding-tag="checkCCEmailTag"
                                    placeholder=""
                                />
                                <div class="help is-danger">{{ccEmailError}}</div>
                                <!-- <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                    </div>
                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary  my-1 ms-2" v-on:click.prevent="addUpdateFormEmailManager('Save')">
                        <input v-show="showSaveAndContinue" id="addBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary  my-1 ms-2" v-on:click.prevent="addUpdateFormEmailManager('Save And Continue')">
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary  my-1 ms-2" v-on:click.prevent="buttonBack">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import axios from 'axios'
    var moment = require('moment-timezone');
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
        name: 'AddUpdateFormEmailManager',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
            VueTagsInput,
        },
        data() {
            return {
                pageTitle : "Add Form Email Manager",
                editId: 0,
                customerId: "",
                customerArr: [],
                customerError: "",
                notificationType: "",
                notificationTypeArr: [
                    /* {
                        text: 'Audit Close Notification',
                        value: 'Audit Close Notification'
                    },
                    {
                        text: 'Audit not Perform',
                        value: 'Audit not Perform'
                    },
                    {
                        text: 'Backorder Parts Notification',
                        value: 'Backorder Parts Notification'
                    },
                    {
                        text: 'Held-Ticket not available',
                        value: 'Held-Ticket not available'
                    },
                    {
                        text: 'Part Usage Notification',
                        value: 'Part Usage Notification'
                    },
                    {
                        text: 'Pending PO Parts Notification',
                        value: 'Pending PO Parts Notification'
                    },
                    {
                        text: 'Magnet Order Request',
                        value: 'Magnet Order Request'
                    }, */
                ],
                notificationTypeError: "",
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                toEmail: "",
                toEmailTagsArr: [],
                isValidToEmailTag: true,
                toEmailError: "",
                ccEmail: "",
                ccEmailTagsArr: [],
                isValidCCEmailTag: true,
                ccEmailError: "",

                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                showSaveAndContinue : true,
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "ListFormEmailManager");
        },
        watch: {
        },
        mounted: function () {
            $("#alertError").hide();
            self.getAllPermissions();
            self.getAllCustomer();
            self.getFormMasterData();
            self.showSaveAndContinue = true;
            if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.editId = self.$route.params.id
                self.getFormEmailManagerDetailsById();
                self.buttonNames.save = "Update";
                self.showSaveAndContinue = false;
                self.pageTitle = "Edit Form Email Manager";
            }
        },
        methods: {
            buttonBack : function () {
                self.$router.push('/form/email/manager/list');
            },
            onChnageCustomer:function() {
                self.customerError = "";
            },
            focusNewTag: function(e) {
                alert();
            },
            checkToEmailTag: function(obj) {
                self.toEmailError = "";
                self.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            checkCCEmailTag: function(obj) {
                self.ccEmailError = "";
                self.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getFormMasterData: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/form/master/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.notificationTypeArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getFormEmailManagerDetailsById: function() {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                    params : {
                        id : self.$route.params.id
                    }
                };
                self.showLoader();
                HTTP.get('/form/email/manager/get', config)
                    .then(response => {
                        if(response.data.content.cc_email && response.data.content.cc_email != 'NULL') {
                            var ccEmailArr = response.data.content.cc_email.split(",");
                            for(var index = 0; index < ccEmailArr.length; index++) {
                                self.ccEmailTagsArr.push({"text": ccEmailArr[index], "tiClasses": ["ti-valid"]});
                            }
                        }
                        if(response.data.content.to_email && response.data.content.to_email != 'NULL') {
                            var toEmailArr = response.data.content.to_email.split(",");
                            for(var index = 0; index < toEmailArr.length; index++) {
                                self.toEmailTagsArr.push({"text": toEmailArr[index], "tiClasses": ["ti-valid"]});
                            }
                        }
                        self.notificationType = {text: response.data.content.notification_type, value: response.data.content.notification_type};
                        self.customerId = {text: response.data.content.customerName, value: response.data.content.customer_id};
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            checkForm: function() {
                var checked = true;
                self.customerError = '';
                self.notificationTypeError = '';
                self.toEmailError = "";
                self.ccEmailError = "";

                if (self.customerId == null || !self.customerId.value) {
                    self.customerError = "Select Customer";
                    checked = false;
                }
                if (self.notificationType == null || !self.notificationType.value) {
                    self.notificationTypeError = "Select Notification Type";
                    checked = false;
                }
                if (self.toEmailTagsArr.length == 0) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addUpdateFormEmailManager(flag) { 
                setTimeout(() => {
                    if (self.isValidCCEmailTag && self.isValidToEmailTag && self.checkForm()) {
                        var toEmailData = "";
                        if(self.toEmailTagsArr && self.toEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.toEmailTagsArr.length;index++) {
                                if(!toEmailData.includes(self.toEmailTagsArr[index].text)) {
                                    toEmailData += (self.toEmailTagsArr[index].text) + ',';
                                }
                            }
                            toEmailData = toEmailData.replace(/,\s*$/, "");
                        }
                        var ccEmailData = "";
                        if(self.ccEmailTagsArr && self.ccEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.ccEmailTagsArr.length;index++) {
                                if(!ccEmailData.includes(self.ccEmailTagsArr[index].text)) {
                                    ccEmailData += (self.ccEmailTagsArr[index].text) + ',';
                                }
                            }
                            ccEmailData = ccEmailData.replace(/,\s*$/, "");
                        }
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };
                        self.disableButtons.save = true;
                        self.disableButtons.saveAndContinue = true;
                        self.disableButtons.cancel = true;
                        if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                            self.buttonNames.save = "Updating ...";
                        } else {
                            if (flag == "Save And Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                            } else {
                                self.buttonNames.save = "Saving ...";
                            }
                        }
                        var fields = {
                            id: self.editId,
                            customer_id: self.customerId.value,
                            notification_type: self.notificationType.value,
                            to_email: toEmailData,
                            cc_email: ccEmailData,
                        };
                        self.showLoader();
                        HTTP.post("/form/email/manager/add/update", fields, config)
                            .then(function (response) {
                                self.disableButtons.save = false;
                                self.disableButtons.saveAndContinue = false;
                                self.disableButtons.cancel = false;
                                if (flag == "Save And Continue") {
                                    self.buttonNames.saveAndContinue = "Save and Continue";
                                } else {
                                    self.buttonNames.save = "Save";
                                    if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                                        self.buttonNames.save = "Update";
                                    }
                                }
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'Save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.disableButtons.save = false;
                                self.disableButtons.saveAndContinue = false;
                                self.disableButtons.cancel = false;
                                self.catchHandler(err);
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function () {
                self.editId = 0;
                self.customerId = "";
                self.notificationType = "";
                self.toEmail = '';
                self.ccEmail = '';
                self.toEmailTagsArr = [];
                self.ccEmailTagsArr = [];
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/FormEmailManagerMaster/AddUpdateFormEmailManager.vue